import { format, isEqual, isWithinInterval } from 'date-fns';
import { FORMAT_DATE } from '../../../constants';

export const SEARCH_OPTIONS = [
  {
    label: 'Usuario',
    value: 'usuario',
    placeholder: 'Buscar por usuario',
  },
  {
    label: 'Doc. identidad',
    value: 'documento',
    placeholder: 'Buscar por doc. identidad',
  },
  {
    label: 'Correo',
    value: 'email',
    placeholder: 'Buscar por correo electrónico',
  },
];

export const ESTADO_OPTIONS = [
  { label: 'Activo', value: true },
  { label: 'Inactivo', value: false },
];

export const generarFiltros = ({ buscador, fecha, estado, roles }) => {
  let filtro = {};

  if (buscador) {
    filtro = buscador.reduce((acc, { key, search }) => {
      let newFilter = {};
      const option = SEARCH_OPTIONS.find(({ label }) => label === key);
      if (option) {
        newFilter = { [option.value]: search };
      }
      return { ...acc, ...newFilter };
    }, {});
  }
  if (estado !== undefined) {
    filtro = { ...filtro, estado: estado?.value };
  }
  if (fecha) {
    filtro = { ...filtro, fechaCreacionDesde: format(fecha[0], FORMAT_DATE.FILTER) };
    if (fecha[1]) {
      filtro = { ...filtro, fechaCreacionHasta: format(fecha[1], FORMAT_DATE.FILTER) };
    }
  }
  if (roles) {
    filtro = { ...filtro, roles: roles.map(({ value }) => value) };
  }
  return filtro;
};

export const filtrarListado = ({ listadoUsuarios, filtros }) => {
  if (!filtros) {
    return listadoUsuarios;
  }
  let listadoFiltrado = listadoUsuarios;

  if (filtros.usuario) {
    listadoFiltrado = listadoFiltrado.filter(({ name, lastname1, lastname2 }) => {
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return fullName.toLowerCase().includes(filtros.usuario.toLowerCase());
    });
  }

  if (filtros.email) {
    listadoFiltrado = listadoFiltrado.filter(({ email }) => email?.toLowerCase().includes(filtros.email.toLowerCase()));
  }

  if (filtros.documento) {
    listadoFiltrado = listadoFiltrado.filter(({ document }) =>
      document?.toLowerCase().includes(filtros.documento.toLowerCase())
    );
  }

  if (filtros.roles) {
    listadoFiltrado = listadoFiltrado.filter(({ role }) => filtros.roles.includes(role));
  }
  if (filtros.estado !== undefined) {
    listadoFiltrado = listadoFiltrado.filter(({ active }) => (filtros.estado ? active : !active));
  }

  if (filtros.fechaCreacionDesde && !filtros.fechaCreacionHasta) {
    listadoFiltrado = listadoFiltrado.filter(({ creationDate }) =>
      isEqual(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), new Date(filtros.fechaCreacionDesde))
    );
  }

  if (filtros.fechaCreacionHasta) {
    listadoFiltrado = listadoFiltrado.filter(({ creationDate }) =>
      isWithinInterval(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), {
        start: new Date(filtros.fechaCreacionDesde),
        end: new Date(filtros.fechaCreacionHasta),
      })
    );
  }

  return listadoFiltrado;
};
